import React, { useContext } from "react";
import { VehiculosContext } from "../../context/VehiculosContext";
import { Modal } from "react-bootstrap";

import iconoCerrar from "../../assets/img/icono-cerrar.svg";
import { FichaTecnica } from "./FichaTecnica";

const ModalFichaTecnica = ({ show, handleClose }) => {
  const { vehiculos, marcaLanding, modeloLanding, arrayVehiculos } = useContext(VehiculosContext);

  return (
    <Modal show={show} onHide={handleClose} centered id="modal-resumen-vehiculo">
      <Modal.Header>
        <h5 className="titulo-modal">Resumen del vehículo</h5>
        <button className="boton-cerrar-modal" onClick={handleClose}>
          <img src={iconoCerrar} alt="" />
        </button>
      </Modal.Header>

      <Modal.Body>
        <h4 className="titulo-secundario-modal">
          {modeloLanding} {vehiculos}
        </h4>
        <FichaTecnica arrayVehiculos={arrayVehiculos} vehiculos={vehiculos} />
      </Modal.Body>
    </Modal>
  );
};

export default ModalFichaTecnica;
